export class LibererDossier
{
    requestId: String;
}